import React from 'react';
import { useSite } from '../context/SiteContext';

const HEIGHTS = { sm: 'h-6', md: 'h-8', lg: 'h-14', xl: 'h-20' };

export default function Logo({ size = 'md', showText = true, dark = false, className = '', testId = 'app-logo' }) {
  const h = HEIGHTS[size] || HEIGHTS.md;
  const { settings } = useSite();
  return (
    <div className={`flex items-center gap-3 min-w-0 ${className}`} data-testid={testId}>
      <img src={settings?.branding?.logoUrl || '/maldhowr-logo.png'} onError={e => { if (!e.currentTarget.src.endsWith('/maldhowr-logo.png')) e.currentTarget.src = '/maldhowr-logo.png'; }} alt="MALDHOWR" className={`${h} w-auto max-w-full object-contain select-none ${dark ? '' : 'drop-shadow-[0_1px_2px_rgba(60,40,0,0.45)]'}`} draggable={false} />
      {showText && size !== 'sm' && (
        <div className={`leading-tight text-[11px] font-semibold uppercase tracking-[0.18em] ${dark ? 'text-amber-200/80' : 'text-slate-500'}`}>
          Savings &amp;<br />Deposits
        </div>
      )}
    </div>
  );
}
